import React, { Suspense, useMemo, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import classes from './GroupUsers.module.css'
import DataManager from '../../hooks/DataManager';
import { addUserToGroup, getGroupUsers, UserPowerSearch } from '../../Api Methods/Api';
import { Await, Outlet } from 'react-router-dom';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import UserList from '../User Management/UserManagementList';
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import InviteGroupUser from './InviteGroupUser';
import { Button } from 'primereact/button';

const GroupUsers = () => {
    const dataManager = new DataManager();
    const groupID = sessionStorage.getItem('groupClickedID');
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const apiData = {
        token,
        client
    }
    const dispatch = useDispatch();
    const [groupUsers, setGroupUsers] = useState();
    const [update, setUpdate] = useState(0);
    const [modalComponent, setModalComponent] = useState();
    const [title, setTitle] = useState('');
    const [success, setSuccess] = useState(false)
    const [fail, setFail] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    const ModalDialog = useRef();

    useEffect(() => {
    }, [groupUsers])

    useEffect(() => {
        fetchUsers()
            .then((response) => {
                setGroupUsers(response.data);  // Set state should trigger re-render
            })
            .catch((error) => {
                console.error('Error fetching users:', error);
            });
    }, [update])

    async function fetchUsers() {
        return await getGroupUsers(apiData, groupID, dispatch)
    }

    const showAddUserModal = () => {
        setTitle("Invite user")
       setModalComponent(
            <InviteGroupUser setSuccess={setSuccess} setFail={setFail} groupID={groupID} update={update} setUpdate={setUpdate} setMessage={setErrorMessage}/>
       )
       HandleShowModal();
    }

    useEffect(() => {
        if (success){
            successModal()
            setSuccess(false)
        }

        if (fail){
            showError()
            setFail(false)
        }

    }, [success, fail])

    const showError = () => {
        setTitle("Error")
        setModalComponent(
            <div>
                <div>
                    <h3 style={{ textAlign: "center" }}>Error</h3>
                </div>
                <div>
                    <p style={{ textAlign: "center" }}>{errorMessage}</p>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px" // Adds space between buttons
                }}>
                    <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
                </div>
            </div>
        )

        HandleShowModal();
    }
    
    const successModal = () => {
        setTitle('Success')
        setModalComponent(
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
            <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Action completed successfully</h3>
            <br />
          <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
          </div>
        )
        HandleShowModal();
      }

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <div className={classes["grid-container"]}>
                <Await resolve={groupUsers}>
                    <>
                        <div style={{ width: "100%", marginBottom: "20px", marginTop: "0px", gap: "10px" }}>
                            <Button1 style={{ height: "50px", width: "210px", fontSize: "16px" }} onClick={showAddUserModal}>Give Portal Admin Access to this group</Button1>
                        </div>

                        <div style={{ display: "flex", width: "100%" }}>
                            {Array.isArray(groupUsers) && groupUsers.length > 0 ? (
                                <UserList data={groupUsers} isGroup={true} update={update} setUpdate={setUpdate} isPortalUsers={true}/>
                            ) : (
                                <p>No users found</p>
                            )}
                        </div>
                    </>
                </Await>
            </div>
        </>
    )
}

export default GroupUsers;